<template>
	<div v-if="children">
		<ul v-bind:class="'list-group list-group-' + groupType">
			<li v-bind:class="'list-group-item oc-' + groupType + '-holder' + (children && children.length > 0 ? 'has-children' : '')" v-for="child in children" v-if="flat || !child.hide">
				 <span class="li-title" v-if="!child.hide">
					<strong v-bind:class="groupType + '-name tree-name'">
						<span v-html="child.display_name_html"></span>
						<span v-html="getAggregates(child)"></span>
						<button class="wol-details-button" @click="showDetails(child)">details</button>
					</strong>
					<span class="inline-context" v-if="flat && child.parent" v-html="getPath(child.parent)"></span>
				</span>
				<taxonomy-list-group :flat="flat" v-bind:groupType="getSubGroupType(child)" v-bind:group="getChilderen(child)" />
			</li>
		</ul>
	</div>
</template>

<script>
export default {
    name: 'TaxonomyListGroup',
    props: ['groupType', 'group', 'flat'],
	mounted(){
	},
	data: function () {
		return {
		}
	},
	methods:{
		getAggregates: function(item) {
			const parts = [];

			if(item.species_count == 0)
				return "";

			if (item.family_count > 0) {
				parts.push(item.family_count + " families");
			}
			if (item.genus_count > 0 || parts.length > 0) {
				parts.push(item.genus_count + " genera");
			}
			parts.push(item.species_count + " species"); // always include species

			if (parts.length === 1 && parts[0] === 0) return "";

			return `<span class="taxon_aggregates">[${parts.join("/")}]</span>`;
		},
		hasChildren: function(child){
			return false;
		},
		showDetails:function(taxon){
			this.$parent.showDetails(taxon);
		},
		getPath:function(item){
			var is_genus = item.parent && this.getSubGroupType(item.parent) == "genera"
			if (is_genus && item.parent) {
				return this.getPath(item.parent);
			}

			var building = item.scientific_name;

			if (item.type == "species") {
				building = "<em>"+building+"</em>";
			}
			
			if (item.parent) {
				building = this.getPath(item.parent) + " > " + building;
			}
			return building;
		},
		getChilderen: function (g){
			if (!g) return null;

			if (Array.isArray(g))
				return g;
			if (g.superfamilies)
				return g.superfamilies;
			if (g.families)
				return g.families;
			if (g.genera) 
				return g.genera;
			if (g.species)
				return g.species;
			if (g.synonyms)
				return g.synonyms;
		},
		getSubGroupType: function (g){
			if (!g) return null;
			if (Array.isArray(g))
				return 'suborders';
			if (g.superfamilies)
				return 'superfamilies';
			if (g.families)
				return 'families';
			if (g.genera)
				return 'genera';
			if (g.species)
				return 'species';
			if (g.synonyms)
				return 'synonyms';
		}
	},
	computed: {
		children: function(){
			return this.getChilderen(this.group);
		},
		children_type: function(){
			return this.getSubGroupType(this.group);
		}
	},
}
</script>


// WEBPACK FOOTER //
// src/components/TaxonomyListGroup.vue